import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-device-new',
  templateUrl: './device-new.component.html',
  styleUrls: ['./device-new.component.scss']
})
export class DeviceNewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
